import validator from "validator";

export function loginFormValidator(values) {
  const errors: any = {};
  if (!values.email) {
    errors.email = "Email field is required";
  } else if (!validator.isEmail(values.email)) {
    errors.email = "Email must be a valid email address";
  }
  if (!values.password) {
    errors.password = "Password field is required";
  }

  return errors;
}
